const ReloadIcon = ({ width = "25", height = "25" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width={width}
    height={height}
    style={{ paddingTop: "3px" }}
    viewBox="0 0 110 125"
    xmlSpace="preserve"
  >
    <g>
      <path d="m87.5 18.75c-1.7266 0-3.125 1.3984-3.125 3.125v6.5117c-6.5781-10.461-17.555-17.359-29.836-18.742-12.277-1.3867-24.516 2.8906-33.262 11.621-8.7422 8.7305-13.039 20.965-11.668 33.242 1.3672 12.281 8.25 23.27 18.699 29.863 10.449 6.5938 23.332 8.0703 35.004 4.0156 11.672-4.0547 20.863-13.199 24.977-24.848 0.57422-1.6289-0.28125-3.4141-1.9102-3.9883-1.6289-0.57031-3.4141 0.28516-3.9844 1.9102-3.5391 10.035-11.523 17.871-21.629 21.215-10.102 3.3438-21.184 1.8242-30.012-4.1172-8.8281-5.9375-14.41-15.629-15.121-26.25-0.70703-10.617 3.5391-20.965 11.504-28.023 7.9609-7.0586 18.742-10.039 29.199-8.0625 10.457 1.9727 19.41 8.6758 24.25 18.152h-8.7109c-1.7266 0-3.125 1.3984-3.125 3.125s1.3984 3.125 3.125 3.125h15.625c0.82812 0 1.625-0.32812 2.2109-0.91406 0.58594-0.58594 0.91406-1.3828 0.91406-2.2109v-15.625c0-0.82812-0.32812-1.625-0.91406-2.2109-0.58594-0.58594-1.3828-0.91406-2.2109-0.91406z" />
    </g>
  </svg>
);
export default ReloadIcon;
